import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { makeObservable, action, observable } from 'mobx';
import 'Styles/commonComponents/FiltersPanel/ShowFiltersButton.scss';
import IconsContainer from 'Utils/IconsContainer';

class ShowFiltersButton extends Component {

    constructor(props) {
        super(props);

    }

    FiltersSelectedCount() {
        return (
            this.props.getSelectedFiltersCount
                ? this.props.getSelectedFiltersCount()
                : Object.values(this.props.getFilters())
                    .filter(filterValue =>
                        filterValue == true
                        &&
                        filterValue?.length > 0 == true
                    ).length
        );
    }

    render() {
        return (
            <div className={`ShowFiltersButton ${this.props.className}`}>
                {this.FiltersSelectedCount() == 0
                    ? (
                        <button
                            className='show-full-filters-button'
                            onClick={() => this.props.showFullFilters()}>
                            {this.props.text ?? "Фильтры"}
                        </button>
                    )
                    : (
                        <div className="show-full-filters-and-clear-filters-container">
                            <button
                                className='show-full-filters-button blue-button'
                                onClick={() => this.props.showFullFilters()}>
                                Фильтры: {this.FiltersSelectedCount()}
                            </button>
                            <button
                                className='clear-filters-button blue-button'
                                onClick={() => {
                                    this.props.clearFilters();
                                }}>
                                {IconsContainer.Get("ci-cross")}
                            </button>
                        </div>
                    )
                }
            </div>
        );
    }
}

export default observer(ShowFiltersButton);